import React from "react";
import {CacheProvider} from "@emotion/react";
import createCache from "@emotion/cache";
import rtlPlugin from "stylis-plugin-rtl";
import {useSelector} from "react-redux";
import {LangCode} from "platform/enum/LangCode";
import {PlatformReduxState} from "platform/redux/PlatformReduxState";

interface IProps {

    children: React.ReactNode;
}

const MuiCache: React.FunctionComponent<IProps> = ({children}: IProps) => {

    const Lang: LangCode = useSelector((state: PlatformReduxState) => state.translation.langCode);

    return (
        <CacheProvider value={createCache({
            key: LangCode.rtlCode(Lang) ? "muirtl" : "muiltr",
            stylisPlugins: LangCode.rtlCode(Lang) ? [rtlPlugin] : [],
        })}>
            {children}
        </CacheProvider>
    )
};

export {
    MuiCache
};
